import * as Common from '@piccolohealth/pbs-common';
import { ChakraV3, Spin } from '@piccolohealth/ui';
import React from 'react';
import { PiccoloError } from '../../components/generic/PiccoloError';
import { useParticipantQuery } from '../../graphql/hooks/useParticipantQuery';
import { useAppContext } from '../../hooks/useAppContext';
import { ParticipantTeamCard } from '../participantTeam/ParticipantTeamCard';
import { ParticipantTaskCard } from '../tasks/ParticipantTaskCard';
import { ParticipantDocumentsCard } from './ParticipantDocumentsCard';
import { ParticipantNotesCard } from './ParticipantNotesCard';
import { ParticipantProfileCard } from './ParticipantProfileCard';

interface Props {
  participantId: string;
  isDisabled: boolean;
}

export const ParticipantDashboard = (props: Props) => {
  const { participantId, isDisabled } = props;

  const { organization } = useAppContext();

  const { data, error, isLoading } = useParticipantQuery({
    organizationId: organization.id,
    participantId,
  });

  const participant = data?.organization?.participant as Common.Participant | undefined;

  if (isLoading) {
    return <Spin />;
  }

  if (error) {
    return <PiccoloError error={error} />;
  }

  if (!participant) {
    return (
      <PiccoloError
        error={
          new Common.PiccoloError({
            type: 'ParticipantNotFound',
            message: 'Participant not found',
          })
        }
      />
    );
  }

  return (
    <ChakraV3.Grid
      h='auto'
      templateRows='repeat(1, 1fr)'
      templateColumns={{ sm: 'repeat(1, 1fr)', '2xl': 'repeat(3, 1fr)' }}
      gap={4}
      pb={4}
      px={6}
      py={4}
    >
      <ChakraV3.GridItem colSpan={{ sm: 1, '2xl': 2 }}>
        <ChakraV3.Stack gap={4}>
          <ParticipantProfileCard participant={participant} isDisabled={isDisabled} />
        </ChakraV3.Stack>
      </ChakraV3.GridItem>
      <ChakraV3.GridItem colSpan={1} pb={4}>
        <ChakraV3.Stack gap={4}>
          <ParticipantTaskCard participant={participant} isDisabled={isDisabled} />
          <ParticipantTeamCard participant={participant} isDisabled={isDisabled} />
          <ParticipantNotesCard participantId={participantId} isDisabled={isDisabled} />
          <ParticipantDocumentsCard participantId={participantId} isDisabled={isDisabled} />
        </ChakraV3.Stack>
      </ChakraV3.GridItem>
    </ChakraV3.Grid>
  );
};
